import { useMemo } from 'react';
import { generatePlaceholderPhotos } from '../utils/custom.utils';
import { Photo } from '../components/PhotoTrio/PhotoTrio.types';

export const useGetFilledPhotos = <T extends Photo>(photos: T[], photoCountToShow: number, fillWithPlaceholderPhotos = true) => {
  const filledPhotos = useMemo(() => {
    const photosToShow: T[] = [...photos.slice(0, photoCountToShow)];
    // Fill remaining slots with placeholder photos
    if (fillWithPlaceholderPhotos && photosToShow.length < photoCountToShow) {
      photosToShow.push(...(generatePlaceholderPhotos(photoCountToShow - photosToShow.length) as T[]));
    }
    return photosToShow;
  }, [photos, photoCountToShow, fillWithPlaceholderPhotos]);

  return { filledPhotos };
};
